/**
 * http://usejsdoc.org/
 */
import { create } from 'apisauce';
import authStore from '../stores/auth-store';
import urlgetter from './getMainUrl';


const api = create({
	baseURL: urlgetter.getMainApiUrl()
});
const func = {};

func.loadFunJumpTypes = () => {
	var token = authStore.getAuthToken();
	if (token == '') {
		token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/admin/loadFunJumpTypes');
}

func.loadItems = () =>{
	// console.log('load price data');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/items/');
}

func.loadTeams = () => {
	var token = authStore.getAuthToken();
	if (token == '') {
		token = localStorage.getItem("Auth-token");
	}
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/admin/teams');
}

func.completeLoad = (loadNum,date) =>{
	if(date==null){
	return api.get('/activeLoads/'+loadNum+'/complete');
	}
	else{
		api.get('/activeLoads/'+loadNum+'/complete?date='+date);
	}
}

func.loadAltitudes = () => {
	  var token = authStore.getAuthToken();
	  if(token == '')
	  {
	     token = localStorage.getItem("Auth-token");
	  }
	  // console.log(token);  
	  api.setHeader('Authorization', 'Bearer ' + token)
	  return api.get('/items/loadAltitudes');
}

func.loadStudentPackages = () => {
	  var token = authStore.getAuthToken();
	  if(token == '')
	  {
	     token = localStorage.getItem("Auth-token");
	  }
	  // console.log(token);  
	  api.setHeader('Authorization', 'Bearer ' + token)
	  return api.get('/items/loadStudentPackages');
}

func.loadJumpersConfig = () => {
	return api.get('/admin/loadJumpersConfig');
}

func.loadSettings = () => {
	  var token = authStore.getAuthToken();
	  if(token == '')
	  {
	     token = localStorage.getItem("Auth-token");
	  }
	  // console.log(token);  
	  api.setHeader('Authorization', 'Bearer ' + token)
	  return api.get('/admin/settings');
}

func.createActiveLoad = (data) =>{
  var payload = {...data};
  //console.log(payload);
  //console.log(urls.mainApiUrl);
 
  var token = authStore.getAuthToken();
  if(token == '')
  {
     token = localStorage.getItem("Auth-token");
  }
  //console.log(token); 
  api.setHeader('Authorization', 'Bearer ' + token)
  return api.post('/activeLoads',payload);
}

func.getAllActiveLoads = () => {
	  //console.log('in get all active loads');
	  return api.get('/activeLoads');
}

func.createTandemJump = (loadNum, jumpPostBody) =>{	

	//console.log('in createTandemJump');
	//console.log(jumpPostBody);
	//var token = authStore.getAuthToken();
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	//console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.post('/activeLoads/'+loadNum+'/tandemJumps', jumpPostBody);
}

func.updateTandemJump = (loadNum, jumpId, jumpPostBody) =>{

	//console.log('in updateTandemJump');
	//var token = authStore.getAuthToken();
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	//console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.put('/activeLoads/'+loadNum+'/tandemJumps/'+jumpId, jumpPostBody);
}

func.updateCompletedAffMediaFolder = (loadNum, jumpId, jumpPostBody) => {
	// console.log('in updateAffJump');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.put('/completedLoads/'+ loadNum +'/affJumps/'+jumpId+"/updateMediaFolder", jumpPostBody);
}

func.updateCompletedCoachMediaFolder = (loadNum, jumpId, jumpPostBody) => {
	// console.log('in updateAffJump');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.put('/completedLoads/'+ loadNum +'/coachJumps/'+jumpId+"/updateMediaFolder", jumpPostBody);
}

func.updateCompletedTandemMediaFolder = (loadNum, jumpId, jumpPostBody) => {
	console.log('in delete tandem Jump');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.put('/completedLoads/'+ loadNum +'/tandemJumps/'+jumpId+"/updateMediaFolder", jumpPostBody);
}

func.cancelTandemJump = (loadNum, jumpId) =>{

	//console.log('in deleteTandemJump');
	//var token = authStore.getAuthToken();
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	//console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.delete('/activeLoads/'+loadNum+'/tandemJumps/'+jumpId);
}



func.createAffJump = (loadNum, jumpPostBody) =>{
	
	//console.log('in createAffJump');
	//console.log(jumpPostBody);
	
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	//console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.post('/activeLoads/' + loadNum + '/affJumps', jumpPostBody);
}

func.updateAffJump = (loadNum, jumpId, jumpPostBody) =>{
	
	//console.log('in updateAffJump');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	//console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.put('/activeLoads/'+loadNum+'/affJumps/'+jumpId, jumpPostBody);
}
func.cancelAffJump = (loadNum, jumpId) =>{
	
	//console.log('in deleteAffJump');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	//console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.delete('/activeLoads/'+loadNum+'/affJumps/'+jumpId);
}
func.createFunJump = (loadNum, jumpPostBody) =>{
	
	//console.log('in create fun jump');
	//console.log(jumpPostBody);
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	
	//console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.post('/activeLoads/'+loadNum+'/funJumps', jumpPostBody);
}
func.updateFunJump = (loadNum, jumpId,jumpPostBody) =>{
	//console.log('in updateTandemJump');
	//alert('in update tandem jump');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	//console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.put('/activeLoads/'+loadNum+'/funJumps/'+jumpId, jumpPostBody);
}
func.addJumpersToFunJump = (loadNum, jumpId, jumpPostBody) =>{
	
	//console.log("in addJumperToFunJump");
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	//console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.post('/activeLoads/'+loadNum+'/funJumps/'+jumpId+'/jumpers', jumpPostBody);
}
func.updateCompletedTandem = (loadId,jumpId, jumpPostBody) =>{
	 
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.put('/completedLoads/'+loadId+'/tandemJumps/'+ jumpId, jumpPostBody);
}
func.updateCompletedAffJump = (loadNum, jumpId, jumpPostBody) =>{
	// console.log('in updateAffJump');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.put('/completedLoads/'+ loadNum +'/affJumps/'+jumpId, jumpPostBody);
}
func.updateCompletedCoachJump = (loadNum, jumpId, jumpPostBody) =>{
	 
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	 
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.put('/completedLoads/'+loadNum+'/coachJumps/'+jumpId, jumpPostBody);
}

func.removeJumperFromFunJump = (loadNum, jumpId, jumperId) =>{

	//console.log("in removeJumperFromFunJump");
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	//console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.delete('/activeLoads/'+loadNum+'/funJumps/'+jumpId+'/jumpers/'+jumperId);
}

func.cancelFunJump = (loadNum, jumpId) =>{

	//console.log('in deleteFunJump');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	//console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.delete('/activeLoads/'+loadNum+'/funJumps/'+jumpId);
}


func.createCoachJump = (loadNum, jumpPostBody) =>{
	//console.log('in createCoachJump');
	//console.log(jumpPostBody);
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	//console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.post('/activeLoads/'+loadNum+'/coachJumps', jumpPostBody);
}

func.updateCoachJump = (loadNum, jumpId, jumpPostBody) =>{
	//console.log('in updateCoachJump');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	//console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.put('/activeLoads/'+loadNum+'/coachJumps/'+jumpId, jumpPostBody);
}

func.cancelCoachJump = (loadNum, jumpId) =>{
	//console.log('in deleteCoachJump');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	//console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.delete('/activeLoads/'+loadNum+'/coachJumps/'+jumpId);
}

func.getCompletedLoad = (startdate, endate) =>{ 
	return api.get('/completedLoads/?start='+ startdate +'&'+'end='+ endate);
}


export default func;
 